module.exports = __webpack_public_path__ + "static/media/back-arrow.ad5a3e3e.svg";